import React, { useState } from "react";
import "./CustomInputField.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { HiInformationCircle } from "react-icons/hi2";
import { RiQuestionFill } from "react-icons/ri";

const CustomInputField = ({ type = "text", name = "", label = "", langLabel = "", langPlaceHolder = "", value = "", func, text1 = null, icon1, icon2, errorSms = null, info = null, checkExist, pattern = null, disabled = false, placeholder = null, agents = false, }) => {
    const [visibleCondition, setVisibleCondition] = useState(false);    // password Visible condition
    const [showLabel, setShowLabel] = useState(false);

    const changeCondition = (() => {    // password check
        setVisibleCondition(!visibleCondition);
    })

    const checkInputForLevel = (e) => {
        if (e.target.value === "undefine" || e.target.value === "" || e.target.value === null) {
            setShowLabel(false);
        }

        if (
            (checkExist)
            &&
            (
                (e.target.name === "username")
                ||
                (e.target.name === "email")
                ||
                (e.target.name === "contact")
                ||
                (e.target.name === "referral_code")
                ||
                (e.target.name === "receiverNameTransfer")
            )
        ) {
            checkExist(e);
        }
    }


    return (
        <div className="custom-input">

            <div onFocus={() => setShowLabel(true)} className={agents ? "module my-0" : "module my-2"}>

                {
                    (name === "address" || showLabel || disabled) ?
                        (<label htmlFor={name} className="">
                            {(langLabel || label)}
                            {name === "referral_code" && <RiQuestionFill fill={"var(--chocolate)"} />}
                        </label>)
                        : null
                }

                {
                    (info) ? <small className="custom-input-info">{info}</small> : ""
                }

                {
                    (errorSms) ? <small className="custom-input-error"><HiInformationCircle size={"14"} className="" style={{ marginBottom: "2px" }} /> {errorSms}</small> : ""
                }

                {
                    (type === "password")
                        ? <div className="input-group">
                            {
                                icon1 && <span className="input-group-text">{icon1}</span>
                            }
                            <input
                                className="form-control"
                                type={visibleCondition ? "text" : "password"}
                                id={name}
                                name={name}
                                placeholder={placeholder || langPlaceHolder || label}
                                value={value}
                                autoComplete="off"
                                onFocus={() => setShowLabel(true)}
                                onChange={func}
                                onBlur={checkInputForLevel}
                                required
                            />
                            <span onClick={changeCondition} className="input-group-text pointer">
                                {
                                    visibleCondition ? <AiFillEye /> : <AiFillEyeInvisible />
                                }
                            </span>
                        </div>
                        :
                        <div className="input-group">
                            {
                                icon1 && <span className="input-group-text">{icon1}</span>
                            }
                            {
                                text1 && <span className="input-group-text phone-code">{text1}</span>
                            }
                            <input
                                type={type}
                                id={name}
                                name={name}
                                placeholder={placeholder || langPlaceHolder || label}
                                value={value}
                                className="form-control"
                                // aria-label="Amount (to the nearest dollar)"
                                autoComplete="off"
                                title={label}
                                onFocus={() => setShowLabel(true)}
                                onChange={func}
                                onBlur={checkInputForLevel}
                                onWheel={event => event.target.blur()}
                                required
                                pattern={pattern}
                                disabled={disabled}
                            />
                            {
                                icon2 && <span className="input-group-text">{icon2}</span>
                            }
                        </div>
                }

            </div>
        </div>
    );
};

export default CustomInputField;

